import type { SanityPageBuilderSection, SanityPageBuilderTextFactsMediaFact, SanityPageBuilderTextFactsMediaSection } from "@ouster/shared";
import { TextFactsMediaBlockView, type TextFactsMediaFact } from "~/features/blocks/inventory/text-facts-media";
import type { Mode, Theme } from "~/features/ui/get-theme-style";
import { SanityMediaFigure } from "~/features/sanity/page-builder/sections/media-figure";
type Props = {
  section: SanityPageBuilderSection & {
    loaded?: boolean;
    sectionContent: SanityPageBuilderTextFactsMediaSection;
  };
};
type TextFactsMediaViewFact = TextFactsMediaFact & Pick<SanityPageBuilderTextFactsMediaFact, "_key">;
export function SanityTextFactsMediaSection({
  section
}: Props) {
  const {
    sectionContent,
    sectionSettings
  } = section;
  const mode = (sectionSettings?.mode || "light") as Mode;
  const theme = (sectionSettings?.theme || "white") as Theme;
  const facts = sectionContent.facts?.map<TextFactsMediaViewFact>(fact => ({
    _key: fact._key,
    label: fact.label,
    title: fact.title
  })) ?? [];
  const mediaMobile = <SanityMediaFigure media={sectionContent.media} ratio="3/2" sizes="lg:50vw" />;
  const mediaDesktop = <SanityMediaFigure media={sectionContent.media} fit="cover" sizes="lg:50vw" />;
  return <TextFactsMediaBlockView anchor={{
    id: sectionSettings?.sectionId?.current || sectionSettings?.anchorName || section._key,
    name: sectionSettings?.anchorName
  }} eyebrow={sectionContent.eyebrow} facts={facts} getFactKey={(fact, index) => fact._key || index} hasTopDivider={sectionSettings?.hasTopDivider ?? true} headline={sectionContent.headline} mediaDesktop={mediaDesktop} mediaMobile={mediaMobile} mode={mode} sectionProps={{
    "data-sanity-section-key": section._key,
    "data-sanity-section-type": section._type
  }} theme={theme} />;
}